interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  return (
    <div
      className={`fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 px-4 transition-all duration-300 ${
        message ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <div className="flex items-center gap-2 rounded-full border border-background-700 bg-foreground-950 px-5 py-3 text-sm text-background-50">
        <i className="ri-checkbox-circle-fill text-lg text-accent-400"></i>
        <span className="whitespace-nowrap text-sm font-medium">{message}</span>
      </div>
    </div>
  );
}